import * as mdijs from '@mdi/js'
import mdiVue from 'mdi-vue/v3'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import 'vuetify/styles'
import App from './App.vue'
import './assets/main.css'
import AdminPage from './components/AdminPage.vue'
import HomeView from './components/HomeView.vue'
import NotFoundView from './components/NotFoundView.vue'

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
          light: {
            colors: {
              green: '#01470f',
            },
          },
        },
      },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },
})

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: HomeView },
        { path: '/admin', component: AdminPage },
        { path: '/404', component: NotFoundView },
        { path: '/:pathMatch(.*)*', component: NotFoundView },
    ],
})

createApp(App)
    .use(vuetify)
    .use(router)
    .use(mdiVue, { icons: mdijs })
    .mount('#app')